import { useMatchMedia } from 'hooks/useMatchMedia';

export type ScreenOrientation = 'landscape' | 'portrait';

/** True when viewport is wider than tall (orientation: landscape). */
export function useOrientation(): ScreenOrientation {
  const landscape = useMatchMedia('(orientation: landscape)');
  return landscape ? 'landscape' : 'portrait';
}
